import React, {Children, cloneElement} from 'react'
import omit from 'lodash/omit'

const AmpSafeImg = (props) => {
  //console.debug("AmpSafeImg", props)  
  return Children.map(
    props.children,
    child => cloneElement(child, {...omit(props, ["ampProps", "zoom", "children"]) })
  );
}

export default AmpSafeImg
